(function(){
  "use strict";
    angular.module('irricrops')

    .controller("vinedoMaiCtrl", ["$scope", 'MultiChart', 'Config','$http','urls','menu','global','$stateParams','temporadaFac', '$timeout',
                          function($scope  , MultiChart , Config  , $http , urls , menu , global , $stateParams, temporadaFac, $timeout){

      var vm               = this;
      var vinedoId         = $stateParams.id;
      var chart            = new MultiChart("Reposición y DTX");
      var yAxis            = chart.agregarEjeY({ titulo : "reposición", medida : "" });
      vm.loadingGeneral    = true;
      vm.equipos           = [];
      vm.temporadas        = [];
      vm.temporadaSelected = null;
      vm.sectoresData      = [];
      vm.sectorSelected    = null;
      vm.chartConfig       = null;
      vm.headerSemanas     = [];

      vm.tabs = [
        {
          tag  : "table",
          name : "tabla"
        },
        {
          tag  : "chart",
          name : "grafico"
        },
      ];




      vm.headerVars = [
        {name : "Dtx", var:"dtx"},
        {name : "Et", var:"et"},
        {name : "Kc", var:"kc"},
      ]

      vm.headerVarsSemActual = [
        {name : "Dtx inf prog", var:"dtx_inf", background:"white", width: 3} ,
        {name : "Dtx sup prog", var:"dtx_sup", background:"white", width: 3},
        {name : "Dtx sug", var:"dtx", editable: true},
        {name : "Et", var:"et"},
        {name : "Kc prog", var:"kc_programa", editable:true, width:2, background:"white"},
        {name : "Ks", var:"ks", editable:true, width:2},
        {name : "freq", var:"cantidadRiego", editable:true, width:2},
        {name : "mm/hrs", var:"precipitacion_sistema", width:2},
        {name : "mm totales", var:"mm_totales", width:2},
        {name : "mm / riego", var:"mm_riego", width:2},
        {name : "hh / riego", var:"hh_riego", width:2},
      ]



      vm.tabSelected = _.first(vm.tabs);

      chart.setTooltipFormatter(function(a, b, c){
        var point = null;  //_.find(this.series.options.localData.data, [this.x, this.y]);
        var x     = this.x;
        var y     = this.y;
        if(this.series && this.series.options.localData.isPoint){
          _.forEach(this.series.options.localData.data, function(d){
            if(d[0]!== null && d[1] !== null){
              if(d[0] == x && d[1] == y){
                point = d[2];
              }
            }
          });
          return " <span class='md-body-2 tooltip-title'><b>Semana:</b> "+point.sem + "</span><br/>"+
          "<b>DTX: </b>"+_.round(this.x, 2)+"<br/> <b>Rep:</b> "+ _.round(this.y, 2)+" <br/>";
        }
        if(this.points && this.points[0].series.options.localData.isLine){
          return "<b>F(x):</b>" + _.round(this.y, 4)+"x + "+ _.round(this.x, 4);
        }
      });


      var getAllIds = function(){
        var ids =_.flatMap(vm.equipos, function(equipo){
          return _.map(equipo.sectores_riego, function(sector){
            return sector.id;
          });
        });
        return ids;
      }


      vm.positionScroll = function(){
        var sem        = _.find(vm.sectoresData[0].semanas, {isActual: true});
        var pos        = vm.sectoresData[0].semanas.indexOf(sem);
        var total      = vm.sectoresData[0].semanas.length;
        var proportion = pos / total;
        $timeout(function(){
          document.querySelector('div.table-container').scrollLeft =
          document.querySelector('div.table-container').scrollWidth * proportion;
        }, 100);
      }




      //INIT
      menu.getSidebarProm().then(function(){
        vm.equipos = global.getSidebarData(vinedoId).equipos;

        temporadaFac.getTemporadas().then(function(data){

          vm.temporadas = data.data.data;
          vm.temporadaSelected = temporadaFac.getActiva();

          vm.getData().then(function(res){
            vm.chartConfig = chart.getConfig();
            vm.loadingGeneral = false;
          });
        });

      });



      vm.calculateTotal = function (sem){
        if(sem.dtx && sem.isActual){
          sem.kc_programa = _.round(sem.dtx * sem.a + sem.b, 2) * 100;
        }else{
          sem.kc_programa = sem.kc_programa_saved;
        }
        sem.mm_totales = sem.et * sem.ks * (sem.kc_programa / 100);
        sem.mm_riego   = sem.mm_totales / sem.cantidadRiego;
        sem.hh_riego   = sem.mm_riego / sem.precipitacion_sistema;
      }





      vm.getData = function(ids){
        if(ids == undefined || ids == null || ids.length == 0){
          ids = getAllIds();
        }

        vm.headerSemanas = [];

        var prom = $http.get(urls.BASE + "/mai/sector", {
          params : {
            'sectores_riego_id[]' : ids,
            fecha_inicio          : moment(vm.temporadaSelected.inicio_date).format("YYYY-MM-DD"),
            fecha_fin             : moment(vm.temporadaSelected.fin_date).format("YYYY-MM-DD"),
          }
        });

        var promResumen = $http({ url: urls.BASE+"/sector-riego/resumen",
          params :{
            'sectores_riego_id[]' : ids,
            fecha_inicio          : moment(vm.temporadaSelected.inicio_date).format("YYYY-MM-DD"),
            fecha_fin             : moment(vm.temporadaSelected.fin_date).format("YYYY-MM-DD"),
          }
        });

        return Promise.all([prom, promResumen])
        .then(function(response){

          var min                = null;
          var max                = null;
          vm.sectoresData        = response[0].data.data;
          vm.sectoresDataResumen = response[1].data.data;
          vm.sectorSelected      = _.first(vm.sectoresData);
          chart.clearSeries();

          _.forEach(vm.sectoresData, function(sector){

            sector.resumen = _.find(vm.sectoresDataResumen.sector_riego, {id: sector.id});
            sector.dtx = 0;

            var data = _.map(sector.semanas, function(sem, semIndex){
              if(sem.dtx !== null){
                if(min == null){
                  min = sem.dtx
                }else if(min > sem.dtx) {
                  min = sem.dtx;
                }

                if(max == null){
                  max = sem.dtx;
                } else if(max < sem.dtx) {
                  max = sem.dtx;
                }
              }




              sem.isActual = false;
              if(moment(new Date()).isBetween(moment(sem.ini), moment(sem.fin))){

                sem.isActual              = true;
                sem.dtx_inf               = sector.resumen.kc.dtx_inf;
                sem.dtx_sup               = sector.resumen.kc.dtx_sup;
                sem.a                     = sector.resumen.kc.a;
                sem.b                     = sector.resumen.kc.b;
                sem.kc_programa           = sector.resumen.kc.kc_programa;
                sem.kc_programa_saved     = sem.kc_programa;
                sem.ks                    = sector.resumen.kc.ks;
                sem.cantidadRiego         = sector.resumen.riego.cantidad;
                sem.precipitacion_sistema = sector.resumen.precipitacion_sistema;
                sector.semanaActual       = sem;
                sector.semanaAnterior     = sector.semanas[semIndex - 1];
                sem.b                     = sector.a;
                sem.a                     = sector.b;
                //sem.sectorObj             = sector;
                //sector.semanaTableData    = [sem];

                sem.mm_totales = 0;
                sem.mm_riego   = 0;
                sem.hh_riego   = 0;
                vm.calculateTotal(sem);
              }


              sector.semanas[semIndex].ini_formated = moment(sem.ini).format("DD [de] MMMM, YYYY");
              sector.semanas[semIndex].fin_formated = moment(sem.fin).format("DD [de] MMMM, YYYY");

              if(sem.dtx !== null && sem.reposicion !== null){
                return [sem.dtx, sem.reposicion, sem];
              }

              return [null, null];
            });

            sector.semanaTableData = sector.semanas;
            if(vm.headerSemanas.length == 0){
              vm.headerSemanas = _.map(sector.semanas, function(sem){
                return {
                  isActual : sem.isActual,
                  sem      : sem.sem,
                  semObj   : sem
                }
              });
            }

            chart.agregarSerie({
              name         :sector.nombre,
              yAxis        : yAxis,
              lineWidth    : 0,
              type         : 'scatter',
              //data         : _.map(data, function(d){return [d[0], d[1]]}),
              //mapea a data, luego elimina los [null, null]
              data         : _.filter(_.map(data, function(d){return [d[0], d[1]]}), function(a){return a[0] !== null && a[1] !== null }),
              visible      : true,
              visibleAxis  : true,
              radius       : 4,
              markerSymbol : 'circle',
              localData    : {
                isPoint : true,
                sector  : sector,
                data    : _.filter(data, function(a){return a[0] !== null && a[1] !== null })
              }
            });






            var a = sector.a;
            var b = sector.b;

            if(a > 0 ){
              var m = 0.5; //margen
              var dataLine = [
                [min-m, (a + (min-m) * b)],
                [max+m, (a + (max+m) * b)]
              ]

              chart.agregarSerie({
                name        : "tendencia "+sector.nombre,
                yAxis       : yAxis,
                lineWidth   : 1,
                type        : 'line',
                data        : dataLine,
                visible     : true,
                visibleAxis : true,
                localData   : {
                  isLine : true,
                  sector : sector,
                  a      : sector.a,
                  b      : sector.b
                }
              });
            }






          })



          chart.setEjeX({
            title   : {
              text : "DTX"
            },
            type : "linear",
            min  : min - 2,
            max  : max + 2,
          }, true);



        }, function(resError){
          console.error(resError);
        });
      }



      vm.selectSectoresCallback = function(param){
        if(param.graficar){
          vm.loadingGeneral = true;
          vm.getData(param.seleccionadosIds).then(function(res){
            vm.chartConfig    = chart.getConfig();
            vm.loadingGeneral = false;
          });
        }
      }

      vm.changeTemporada = function(res){
        vm.loadingGeneral = true;
        vm.chartConfig    = null;
        vm.getData().then(function(res){
          vm.chartConfig    = chart.getConfig();
          vm.loadingGeneral = false;
        });
      }



  }]);
})();
